<template>
    <div class="box">

        <h5 class="text-muted" v-if="dataLabel">
            {{dataLabel}}
        </h5>

        <div class="box-wrapper" :style="{width: dataWidth}">

            <i class="mdi" :class="dataIcon" v-if="dataIcon"></i>

            <slot></slot>

        </div>

    </div>
</template>

<script>
    export default {
        props: {
            value: {
            },

            dataLabel: {
                type: String
            },

            dataIcon: {
                type: String
            },

            dataWidth: {
                type: String,
                default: '175px'
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import "~@variables";

    .box {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1 0 auto;

        .box-wrapper {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 55px;
            padding: 0 15px;
            border: $border-1;
            border-radius: 4px;
            font-weight: bold;
            color: $grey-4;

            .mdi {
                font-size: 24px;
            }
        }
    }
</style>
